import config from '@/config/config';

export default {
  isLoggedIn: (state) => {
    return state.token && state.token.length > 0 && state.course.id && state.course.id.length > 0;
  },
  courseComponent: (state) => {
    switch(state.currentCourse) {
      case config.initial.course.lecture:
        return 'Lecture';
      case config.initial.course.video:
        return 'Video';
      case config.initial.course.materials:
        return 'Materials';
      case config.initial.course.finish:
        return 'Finish';
      case config.initial.course.exam:
        return 'Exam';
      case config.initial.course.start:
      default:
        return 'Info';
    }
  },
};
